export default __webpack_public_path__ + "static/ringtube-87b3c12cd30899893b51420b28900673.png";